import gql from 'graphql-tag'

export const QUESTION_CONNECTION = gql`
  query QUESTION_CONNECTION(
    $where: QuestionWhereInput
    $skip: Int
    $first: Int
    $orderBy: QuestionOrderByInput
  ) {
    questionsConnection(
      where: $where
      skip: $skip
      first: $first
      orderBy: $orderBy
    ) {
      edges {
        node {
          id
          category {
            id
            content
          }
          title
          content
          createdAt
        }
      }
      aggregate(where: $where) {
        count
      }
    }
  }
`
export const QUESTION_CATEGORY = gql`
  query QuestionCategories($where: QuestionCategoryWhereInput) {
    questionCategories(where: $where) {
      id
      content
    }
  }
`
